import { authPost } from './authMiddleware';

export const postMovePortfolio = (data) => {
    return authPost('/api/portfolio/folder-item', data);
}